import { Container, Stack, Typography, Button, Box, Dialog, IconButton } from "@mui/material";
import { useEffect, useState, useContext, useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import useEmblaCarousel from "embla-carousel-react";
import axios from "axios";
import { Store } from "../Store";
import CloseIcon from "@mui/icons-material/Close";

const ProjectDetails = () => {
  const { state } = useContext(Store);
  const { userInfo } = state;
  const navigate = useNavigate();
  const { id } = useParams();

  const [project, setProject] = useState(null);
  const [openImage, setOpenImage] = useState(null);
  const [emblaRef, emblaApi] = useEmblaCarousel({ loop: true });

  const fetchProject = useCallback(async () => {
    try {
      const res = await axios.get(`https://api.aghayev-marjanscy.pl/api/projects/${id}`);
      setProject(res.data.project);
    } catch (err) {
      console.log(err);
    }
  }, [id]);

  const deleteProject = async () => {
    try {
      await axios.delete(`https://api.aghayev-marjanscy.pl/api/projects/${id}`, {
        headers: { Authorization: `Bearer ${userInfo.token}` },
      });
      navigate("/");
    } catch (err) {
      console.log(err);
    }
  };

  const handleEdit = () => {
    navigate(`/projects/edit/${id}`);
  };

  const scrollPrev = () => emblaApi && emblaApi.scrollPrev();
  const scrollNext = () => emblaApi && emblaApi.scrollNext();

  useEffect(() => {
    fetchProject();
  }, [fetchProject]);

  return (
    <Container sx={{ pt: 5 }}>
      {project?.images?.length > 0 && (
        <Box>
          <Box sx={{ overflow: "hidden", width: "100%" }} ref={emblaRef}>
            <Box sx={{ display: "flex" }}>
              {project.images.map((imageSrc, index) => (
                <Box
                  key={index}
                  sx={{
                    flex: "0 0 100%",
                    minWidth: 0,
                    px: 1,
                  }}
                >
                  <Box
                    sx={{
                      width: "100%",
                      height: { xs: 250, md: 500 },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      backgroundColor: "#000",
                      borderRadius: 2,
                      overflow: "hidden",
                    }}
                  >
                    <Box
                      component="img"
                      src={imageSrc}
                      alt={`${project.title || "Project"} ${index + 1}`}
                      onClick={() => setOpenImage(imageSrc)}
                      sx={{
                        maxWidth: "100%",
                        maxHeight: "100%",
                        objectFit: "contain",
                        display: "block",
                        cursor: "pointer",
                      }}
                    />
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>

          {project.images.length > 1 && (
            <Stack
              direction="row"
              spacing={2}
              sx={{ mt: 2, justifyContent: "center" }}
            >
              <Button variant="outlined" onClick={scrollPrev}>
                Poprzednie
              </Button>
              <Button variant="outlined" onClick={scrollNext}>
                Następne
              </Button>
            </Stack>
          )}
        </Box>
      )}

      <Stack>
        <Typography paddingTop="32px" textAlign="left">
          Nazwa: {project?.title}
        </Typography>
        <Typography textAlign="left">Program: {project?.program}</Typography>
        <Typography textAlign="left">
          Powierzchnia: {project?.surface}
        </Typography>
        <Typography textAlign="left">
          Lokalizacja: {project?.location}
        </Typography>
        <Typography textAlign="left">Inwestor: {project?.investor}</Typography>
        <Typography textAlign="left">Zespół: {project?.team}</Typography>
        <Typography textAlign="left">
          Status Projektu: {project?.projectStatus}
        </Typography>
        <Typography textAlign="left">
          Kategoria: {project?.category}
        </Typography>
        <Typography textAlign="left" paddingBottom="32px">
          Rok: {project?.year}
        </Typography>
        <Typography textAlign="justify">{project?.description}</Typography>
      </Stack>

      {userInfo && (
        <Stack
          direction="row"
          sx={{
            justifyContent: "space-between",
            flexWrap: "wrap",
            mt: 3,
          }}
        >
          <Button onClick={deleteProject}>USUŃ</Button>
          <Button onClick={handleEdit}>Edytuj</Button>
        </Stack>
      )}
      <Dialog
        open={!!openImage}
        onClose={() => setOpenImage(null)}
        maxWidth="lg"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            backgroundColor: "black",
          },
        }}
      >
        <Box sx={{ position: "relative" }}>
          <IconButton
            onClick={() => setOpenImage(null)}
            sx={{
              position: "absolute",
              top: 8,
              right: 8,
              color: "#fff",
              backgroundColor: "rgba(0,0,0,0.5)",
              "&:hover": {
                backgroundColor: "rgba(0,0,0,0.7)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box
            component="img"
            src={openImage}
            sx={{
              width: "100%",
              maxHeight: "90vh",
              objectFit: "contain"
            }}
          />
        </Box>
      </Dialog>
    </Container>
  );
};

export default ProjectDetails;
